import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { OVERVIEWS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/overviews/new")({
  component: () => <DeptContentForm cfg={OVERVIEWS} />,
});
